export default "__VITE_ASSET__D6PQ3SKm__"